<template>
  <div id="admin-users-delete">
    <Title title="Usuarios"
           subtitle="Gestión de cuentas y desactivación"/>
    <el-form v-model="filter"
             :model="filter"
             :inline="true"
             ref="formFilterUsers">
      <el-form-item>
        <el-input v-model="filter.accounts_rut"
                  style="width: 200px;"
                  placeholder="RUT"
                  clearable/>
      </el-form-item>
      <el-form-item>
        <el-input v-model="filter.accounts_email"
                  style="width: 200px;"
                  placeholder="EMAIL"
                  clearable/>
      </el-form-item>
      <el-form-item>
        <el-input v-model="filter.accounts_name"
                  style="width: 200px;"
                  placeholder="NOMBRE"
                  clearable/>
      </el-form-item>
      <el-form-item>
        <el-button class="btn primary searchBttn"
                   @click="handleSearch">
          <i class="fa fa-search"></i>
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="btn primary searchBttnC"
                   @click="cleanFilter">
          <i class="fas fa-broom"></i>&nbsp;&nbsp;LIMPIAR
        </el-button>
      </el-form-item>
    </el-form>
    <el-container class="content">
      <el-table :data="data.usersList" size="mini" class="tableRoutes"
                height="400px" width="100%" fit style="z-index: 1;"
                tooltip-effect="dark"
                v-loading="loadTruck">
        <el-table-column  label="RUT"
                          align="left"
                          min-width="100"
                          prop="rut">
        </el-table-column>
        <el-table-column  label="EMAIL"
                          align="left"
                          show-overflow-tooltip
                          min-width="200"
                          prop="email">
        </el-table-column>
        <el-table-column  label="NOMBRE"
                          align="left"
                          show-overflow-tooltip
                          min-width="150"
                          prop="name">
        </el-table-column>
        <el-table-column  label="APELLIDO"
                          align="left"
                          show-overflow-tooltip
                          min-width="150"
                          prop="last_name">
        </el-table-column>
        <el-table-column  label="TIPO DE USUARIO"
                          align="left"
                          show-overflow-tooltip
                          min-width="150"
                          prop="account_types_id">
          <template slot-scope="scope"
                    align="center">
            {{ typeAccount(scope.row.account_types_id) }}
          </template>
        </el-table-column>
        <el-table-column label="EMPRESAS"
                         align="center"
                         min-width="110">
          <template slot-scope="scope"
                    align="center">
            <div class="inhouse-enterprises-cell">
              <el-button v-if="scope.row.account_types_id === 7 || scope.row.account_types_id === 8"
                         type="text"
                         size="mini"
                         @click="openEditEnterprises(scope.row)">
                EDITAR
              </el-button>
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column  label="ESTADO"
                          min-width="150"
                          align="center"
                          prop="active">
          <el-switch slot-scope="scope"
                     v-model="scope.row.active"
                     active-color="#AAD500"
                     @change="checkUpdate(scope.row)">
          </el-switch>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="22" :offset="1" class="toolbar">
          <el-pagination layout="total, prev, pager, next"
                         @current-change="handleCurrentChange"
                         :page-size="10"
                         :total="totalSize"
                         style="float:right;">
          </el-pagination>
        </el-col>
      </el-row>
    </el-container>
    <el-dialog :title="dialogTitle"
               :visible.sync="dialog.editEnterprises"
               width="960px">
      <div v-loading="editEnterprisesLoading">
        <p v-if="editEnterprisesUser.id" class="dialog-subtitle">
          {{ editEnterprisesUser.name }} {{ editEnterprisesUser.last_name }}
        </p>
        <p class="dialog-detail">
          Empresas actuales: {{ formatEnterprises(editEnterprisesUser) }}
        </p>
        <el-form class="enterprise-edit-form" @submit.native.prevent>
          <el-form-item :label="editEnterprisesUser.account_types_id === 8 ? 'Empresa asociada' : 'Empresas asociadas'">
            <el-select v-model="editFormEnterpriseIds"
                       :multiple="editEnterprisesUser.account_types_id === 7"
                       filterable
                       style="width: 100%;"
                       :placeholder="editEnterprisesUser.account_types_id === 8 ? 'Seleccione una opción' : 'Seleccione una o más empresas'"
                       no-data-text="Cargando...">
              <el-option v-for="enterprise in sortedEnterpriseOptions"
                         :key="enterprise.id"
                         :label="enterprise.name"
                         :value="enterprise.id"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="dialog.editEnterprises = false">CANCELAR</el-button>
        <el-button class="default"
                   :loading="savingEnterprises"
                   @click="updateInhouseEnterprises">
          GUARDAR
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiRequest } from '@/backend/vue-axios/axios';
import { startRumTiming, getRumDuration, trackBusinessFlow } from '@/observability/datadogRum';
import formFunctions from '../../../mixins/form';
import Title from '../../components/base/Title.vue';

export default {
  name: 'UserList',
  data() {
    return {
      filter: {
        accounts_name: '',
        accounts_rut: '',
        accounts_email: '',
        limit: 10,
      },
      type: [
        '',
        'ADMINISTRADOR',
        'PLANNER',
        'JEFE DE REPARTO',
        'CONDUCTOR',
        'SUPERVISOR DE TRANSPORTE',
        'SAC',
        'INHOUSE TREN LOGISTICO',
        'GESTOR LOGISTICO',
      ],
      data: {
        usersList: [],
      },
      dialog: {
        editEnterprises: false,
      },
      editForm: {
        accountId: null,
        enterprise_ids: [],
      },
      editEnterprisesUser: {},
      editEnterprisesLoading: false,
      savingEnterprises: false,
      enterpriseOptions: [],
      loadTruck: false,
      totalSize: 0,
      // de aca para arriba
      component: this,
      form_name: 'formFilterUsers',
      formFunctions,
      variables: {
        component: this,
        module: 'crud',
        service: null,
        pathparam: null,
        condition: null,
        message: {
          error: 'la cuenta no existe, por favor intente nuevamente',
          success: 'La cuenta ha sido desactivada',
        },
        params: null,
      },
    };
  },
  components: {
    Title,
  },
  computed: {
    editFormEnterpriseIds: {
      get() {
        if (this.editEnterprisesUser.account_types_id === 8) {
          return this.editForm.enterprise_ids[0] || null;
        }
        return this.editForm.enterprise_ids;
      },
      set(value) {
        if (this.editEnterprisesUser.account_types_id === 8) {
          this.editForm.enterprise_ids = value ? [value] : [];
        } else {
          this.editForm.enterprise_ids = value || [];
        }
      },
    },
    sortedEnterpriseOptions() {
      if (!Array.isArray(this.enterpriseOptions) || this.enterpriseOptions.length === 0) {
        return [];
      }

      const selectedIds = new Set(this.editForm.enterprise_ids.map(id => Number(id)));

      return [...this.enterpriseOptions].sort((leftEnterprise, rightEnterprise) => {
        const leftSelected = selectedIds.has(Number(leftEnterprise.id));
        const rightSelected = selectedIds.has(Number(rightEnterprise.id));

        if (leftSelected !== rightSelected) {
          return leftSelected ? -1 : 1;
        }

        return leftEnterprise.name.localeCompare(rightEnterprise.name);
      });
    },
    dialogTitle() {
      return this.editEnterprisesUser.account_types_id === 8
        ? 'Editar empresa - Gestor Logístico'
        : 'Editar empresas InHouse';
    },
  },
  methods: {
    typeAccount(id) {
      return this.type[id];
    },
    formatEnterprises(user) {
      if (user.account_types_id !== 7 && user.account_types_id !== 8) {
        return '-';
      }

      if (user.enterprisesLoading) {
        return 'Cargando empresas...';
      }

      if (!user.enterprises || user.enterprises.length === 0) {
        return 'Sin empresas asociadas';
      }

      return user.enterprises.map(enterprise => {
        const id = enterprise.id || enterprise;
        const option = this.enterpriseOptions.find(opt => Number(opt.id) === Number(id));
        return option ? option.name : `ID: ${id}`;
      }).join(', ');
    },
    setUserEnterprises(accountId, enterprises) {
      const userIndex = this.data.usersList.findIndex(user => user.id === accountId);

      if (userIndex === -1) {
        return;
      }

      this.$set(this.data.usersList[userIndex], 'enterprises', enterprises);
      this.$set(this.data.usersList[userIndex], 'enterprisesLoading', false);
    },
    getUserById(accountId) {
      return this.data.usersList.find(user => user.id === accountId);
    },
    fetchInhouseEnterprises(accountId) {
      return apiRequest({
        module: 'crud',
        service: 'get_inhouse_tren_logistico_enterprises',
        pathparam: { id: accountId },
      }).then((response) => {
        const enterprises = response.data && response.data.enterprises
          ? response.data.enterprises
          : [];
        this.setUserEnterprises(accountId, enterprises);
        return enterprises;
      }).catch((error) => {
        console.error('fetchInhouseEnterprises error:', error);
        this.setUserEnterprises(accountId, []);
        return [];
      });
    },
    loadEnterpriseOptions() {
      if (this.enterpriseOptions.length > 0) {
        return Promise.resolve(this.enterpriseOptions);
      }

      return apiRequest({
        module: 'planning',
        service: 'enterprises',
        params: { limit: 6000 },
      }).then((response) => {
        this.enterpriseOptions = response.data || [];
        return this.enterpriseOptions;
      });
    },
    openEditEnterprises(user) {
      this.dialog.editEnterprises = true;
      this.editEnterprisesLoading = true;
      this.editEnterprisesUser = user;
      this.editForm.accountId = user.id;
      this.editForm.enterprise_ids = [];

      Promise.all([
        this.loadEnterpriseOptions(),
        this.fetchInhouseEnterprises(user.id),
      ]).then(([, enterprises]) => {
        this.editForm.enterprise_ids = enterprises.map(enterprise => enterprise.id);
      }).catch((error) => {
        console.error('Error loading:', error);
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'No fue posible cargar las empresas del usuario',
        });
        this.dialog.editEnterprises = false;
      }).finally(() => {
        this.editEnterprisesLoading = false;
      });
    },
    updateInhouseEnterprises() {
      const isType8 = this.editEnterprisesUser.account_types_id === 8;
      const hasValidEnterpriseIds = Array.isArray(this.editForm.enterprise_ids)
        && this.editForm.enterprise_ids.length > 0;

      if (!hasValidEnterpriseIds) {
        this.$notify({
          type: 'warning',
          title: 'Validación',
          message: isType8 ? 'Seleccione una empresa' : 'Seleccione al menos una empresa',
        });
        return;
      }

      this.savingEnterprises = true;
      apiRequest({
        module: 'crud',
        service: 'update_inhouse_tren_logistico_enterprises',
        pathparam: { id: this.editForm.accountId },
        params: {
          enterprise_ids: this.editForm.enterprise_ids.map(id => Number(id)),
        },
      }).then(() => this.fetchInhouseEnterprises(this.editForm.accountId)).then(() => {
        const updatedUser = this.getUserById(this.editForm.accountId);
        if (updatedUser) {
          this.editEnterprisesUser = updatedUser;
        }
        this.dialog.editEnterprises = false;
        this.$notify({
          type: 'success',
          title: 'Completado',
          message: 'Empresas actualizadas con éxito',
        });
      }).catch((error) => {
        const status = error && error.response ? error.response.status : null;
        let message = error && error.response && error.response.data
          ? error.response.data.message
          : 'No fue posible actualizar las empresas';

        if (status === 400) {
          message = 'Datos inválidos. Revisa las empresas seleccionadas.';
        } else if (status === 404) {
          message = 'La cuenta o alguna empresa seleccionada no existe.';
        }

        this.$notify({
          type: 'error',
          title: 'Error',
          message,
        });
      })
        .finally(() => {
          this.savingEnterprises = false;
        });
    },
    enrichInhouseUsers(users) {
      const usersList = users.map(user => ({
        ...user,
        enterprises: user.enterprises || [],
        enterprisesLoading: user.account_types_id === 7 || user.account_types_id === 8,
      }));
      const inhouseUsers = usersList.filter(user => user.account_types_id === 7 || user.account_types_id === 8);

      if (inhouseUsers.length === 0) {
        this.data.usersList = usersList;
        return;
      }

      this.data.usersList = usersList;

      Promise.all(inhouseUsers.map(user => this.fetchInhouseEnterprises(user.id).catch(() => [])));
    },
    validEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getStatus(parameter = {}) {
      this.loadTruck = true;
      apiRequest(
        {
          module: 'crud',
          service: 'get_list_accounts',
          params: parameter,
        },
      ).then((res) => {
        this.enrichInhouseUsers(res.data);
        this.totalSize = parseInt(res.headers['x-total-count'], 10);
        this.loadTruck = false;
      }).catch(() => {
        this.loadTruck = false;
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al cargar las Rutas',
        });
      });
    },
    checkUpdate(a) {
      const param = {
        toggle: a.active,
        account_id: a.id,
      };
      this.updateUsers(param, a);
    },
    updateUsers(parameter = {}, user = {}) {
      const startedAt = startRumTiming();
      const action = parameter.toggle ? 'activate_user' : 'deactivate_user';
      this.loadTruck = true;
      apiRequest(
        {
          module: 'crud',
          service: 'update_accounts',
          params: parameter,
        },
      ).then(() => {
        trackBusinessFlow({
          module: 'users',
          flow: 'user_management',
          action,
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            target_user_id: user.id || parameter.account_id || 'unknown',
            target_user_email: user.email || 'unknown',
            target_user_name: [user.name, user.last_name].filter(Boolean).join(' ') || 'unknown',
            target_account_type: user.account_types_id || 'unknown',
            target_user_active: parameter.toggle,
          },
        });
        this.$notify({
          title: 'OK',
          message: 'Usuario modificado con éxito',
          type: 'success',
        });
        this.getStatus(this.filter);
        this.loadTruck = false;
      }).catch((error) => {
        trackBusinessFlow({
          module: 'users',
          flow: 'user_management',
          action,
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            target_user_id: user.id || parameter.account_id || 'unknown',
            target_user_email: user.email || 'unknown',
            target_user_name: [user.name, user.last_name].filter(Boolean).join(' ') || 'unknown',
            target_account_type: user.account_types_id || 'unknown',
            target_user_active: parameter.toggle,
            error_message: error.response && error.response.data
              ? error.response.data.message
              : 'unknown_error',
          },
        });
        this.loadTruck = false;
        this.$notify({
          type: 'error',
          title: 'Error',
          message: error.response.data.message,
        });
      });
    },
    getLimitPage(page) {
      return ((page - 1) * 20);
    },
    handleCurrentChange(newPage) {
      this.loadTruck = true;
      this.getStatus({
        offset: this.getLimitPage(newPage),
        name: this.filter.name,
        email: this.filter.email,
        rut: this.filter.rut,
        limit: this.filter.limit,
      });
    },
    cleanFilter() {
      this.filter.accounts_rut = '';
      this.filter.accounts_name = '';
      this.filter.accounts_email = '';
    },
    handleSearch() {
      this.getStatus(this.filter);
    },
  },
  created() {
    this.loadTruck = true;
    this.getStatus(this.parameter);
  },
};
</script>

<style  lang="scss" scoped>
.el-form {
  display: flex;
}
.el-form-item {
  position: relative;
}
.el-input__inner{
  height: 40px !important;
}
.content {
  text-align: left;
  margin: 0 30px 0 30px;
  display: grid;
}
.searchBttnC {
  margin-top: 1px;
  height: 40px;
  width: 120px;
}
.searchBttn {
  margin-top: 1px;
  height: 40px;
}
.inhouse-enterprises-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-subtitle {
  margin-top: 0;
  margin-bottom: 8px;
  color: #616161;
  font-weight: 700;
}
.dialog-detail {
  margin-top: 0;
  margin-bottom: 16px;
  color: #757575;
}
.enterprise-edit-form {
  width: 100%;
}
.enterprise-edit-form ::v-deep .el-form-item__content {
  width: 100%;
}
.enterprise-edit-form ::v-deep .el-select__tags {
  max-width: calc(100% - 48px) !important;
}
@media only screen and (min-height: 900px) {
  .el-table {
    height: 600px !important;
  }
}
</style>
